import React from 'react';
import type { Block, BlockStatus } from '../utils/blocks';
interface LedgerEntryProps {
  block: Block;
  onActivityChange: (id: number, value: string) => void;
  onToggle: (id: number, status: Exclude<BlockStatus, null>) => void;
}
export function LedgerEntry({
  block,
  onActivityChange,
  onToggle
}: LedgerEntryProps) {
  return <div className={`entry${block.status ? ` marcado ${block.status}` : ''}`} data-id="element-48" data-mp="3ghqpp9mdddz">
      <div className="hora" data-id="element-49" data-mp="r750yh70cf3p">{block.label}</div>
      <div className="entry-body" data-id="element-50" data-mp="w4x3e55a3jm5">
        <label className="sr-only" htmlFor={`act-${block.id}`} data-id="element-51" data-mp="w56jn10iucen">
          Actividad de las {block.label}
        </label>
        <input id={`act-${block.id}`} type="text" placeholder="¿Qué hiciste ayer en este bloque?" value={block.activity} onChange={e => onActivityChange(block.id, e.target.value)} data-id="element-52" data-mp="hf7jwttbisx2" />
        <div className="toggle" data-id="element-53" data-mp="1eveg509pu4lv">
          <button type="button" aria-pressed={block.status === 'crecimiento'} className={block.status === 'crecimiento' ? 'on-crecimiento' : ''} onClick={() => onToggle(block.id, 'crecimiento')} data-id="element-54" data-mp="1evo6ioyoads3">
            Sumó
          </button>
          <button type="button" aria-pressed={block.status === 'fuga'} className={block.status === 'fuga' ? 'on-fuga' : ''} onClick={() => onToggle(block.id, 'fuga')} data-id="element-55" data-mp="2gfkxqiuyh8m8">
            No sumó
          </button>
        </div>
      </div>
    </div>;
}